/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

export function formatIndianNumber(value) {

    const num = Number(value);

    if (!Number.isFinite(num))
        return "-";

    const abs = Math.abs(num);

    if (abs >= 10000000) {

        return (
            (num / 10000000)
                .toFixed(2) +
            " Cr"
        );

    }

    if (abs >= 100000) {

        return (
            (num / 100000)
                .toFixed(2) +
            " L"
        );

    }

    // if (abs >= 1000) {
    //
    //     return (
    //         (num / 1000)
    //             .toFixed(2) +
    //         " K"
    //     );
    //
    // }

    return num.toLocaleString(
        "en-IN"
    );

}